var React = require('react');

function CrossClosure (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.1006 0.353747L1.35359 18.1007M18.3935 18.1005L0.646484 0.353516"}));
}

CrossClosure.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = CrossClosure;

CrossClosure.default = CrossClosure;
